"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineageNav = void 0;
const tslib_1 = require("tslib");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LineageConfiguration_1 = require("../placePage/LineageConfiguration");
const LineageCartoucheStyles_1 = require("../style/LineageCartoucheStyles");
const FilterIndicatorWithClearButton_1 = require("./FilterIndicatorWithClearButton");
const LineageAnchor_1 = require("./LineageAnchor");
const LineageCartouche_1 = require("./LineageCartouche");
const LineageNavStyles_1 = require("./LineageNavStyles");
const SingleLineageItem_1 = require("./SingleLineageItem");
class LineageNav extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.rendererForLineageSectionType = {
            /* eslint-disable @typescript-eslint/no-unsafe-assignment */
            [LineageConfiguration_1.LineageSectionType.Group]: this.renderCartouche.bind(this),
            [LineageConfiguration_1.LineageSectionType.Anchor]: this.renderAnchor.bind(this),
            [LineageConfiguration_1.LineageSectionType.Owners]: this.renderSingleItem.bind(this),
            /* eslint-enable @typescript-eslint/no-unsafe-assignment */
        };
    }
    hasInitialLoadCompleted() {
        return !!this.props.unfilteredCounts;
    }
    render() {
        const contents = this.hasInitialLoadCompleted()
            ? (react_1.default.createElement(react_1.default.Fragment, null,
                this.renderHeader(),
                this.renderNavItems()))
            : this.renderLoadingIndicator();
        return (react_1.default.createElement(LineageNavStyles_1.LineageNavContainer, { "data-tb-test-id": 'lineage-nav-container' },
            react_1.default.createElement(vizportalclient_common_components_1.VerticalFlexContainer, { fillFlexParent: true, additionalClassNames: [LineageNavStyles_1.lineageNavCssClass] }, contents)));
    }
    renderLoadingIndicator() {
        return react_1.default.createElement(vizportalclient_common_components_1.CenteredFadeInSpinner, null);
    }
    renderHeader() {
        return (react_1.default.createElement(LineageNavStyles_1.LineageNavHeader, { "data-tb-test-id": 'lineage-nav-header' },
            react_1.default.createElement(vizportalclient_common_components_1.HorizontalFlexContainer, { additionalClassNames: [LineageNavStyles_1.lineageHeaderClass] },
                react_1.default.createElement("span", null,
                    this.props.shouldShowFlowParametersWarning
                        && (react_1.default.createElement(widgets_1.Tooltip, { getContent: () => react_1.default.createElement("div", null, catalog_messages_1.Messages.FlowParametersLineageWarning()) },
                            react_1.default.createElement(catalog_icons_1.SvgWarning, { style: { marginRight: 8 } }))),
                    catalog_messages_1.Messages.LineageNavHeader()),
                this.props.filteredItemName
                    ? (react_1.default.createElement(FilterIndicatorWithClearButton_1.FilterIndicatorWithClearButton, { clearFilters: this.props.clearFilters, filteredItemName: this.props.filteredItemName }))
                    : null)));
    }
    renderNavItems() {
        const sectionsToRender = this.getItemsWithNonzeroCounts();
        const renderedSections = sectionsToRender.map(section => this.rendererForLineageSectionType[section.sectionType](section));
        const sectionsWithConnectors = [];
        renderedSections.forEach((section, i) => {
            if (i !== 0) {
                sectionsWithConnectors.push(react_1.default.createElement(LineageCartoucheStyles_1.CartoucheConnectorLine, { key: i }));
            }
            sectionsWithConnectors.push(section);
        });
        return sectionsWithConnectors;
    }
    getItemsWithNonzeroCounts() {
        const configSections = this.props.lineageConfiguration;
        const sectionsWithFilteredItems = configSections.map(section => {
            // Certain section types should never be removed
            if (section.sectionType === LineageConfiguration_1.LineageSectionType.Anchor || section.sectionType === LineageConfiguration_1.LineageSectionType.Owners) {
                return section;
            }
            const filteredItems = section.items.filter(item => this.props.unfilteredCounts && item.count(this.props.unfilteredCounts));
            return Object.assign(Object.assign({}, section), { items: filteredItems });
        });
        const filteredSections = sectionsWithFilteredItems.filter(section => section.items.length > 0);
        return filteredSections;
    }
    getLineageLabel(item) {
        let upstreamDataCloudObjectsFilteredCount = 0;
        if (item.dataCloudObjectCount) {
            if (this.props.filteredCounts !== null) {
                upstreamDataCloudObjectsFilteredCount = item.dataCloudObjectCount(this.props.filteredCounts);
            }
        }
        let upstreamDataCloudObjectsUnFilteredCount = 0;
        if (item.dataCloudObjectCount) {
            if (this.props.unfilteredCounts !== null) {
                upstreamDataCloudObjectsUnFilteredCount = item.dataCloudObjectCount(this.props.unfilteredCounts);
            }
        }
        let lineageLabel = item.messagesForLineage.withoutCount();
        if (upstreamDataCloudObjectsUnFilteredCount > 0 || upstreamDataCloudObjectsFilteredCount > 0) {
            lineageLabel = catalog_messages_1.Messages.TablesAndObjects();
        }
        return lineageLabel;
    }
    renderCartouche(section) {
        const lineageItems = section.items.map(item => this.getLineageItemProps(item, section));
        return react_1.default.createElement(LineageCartouche_1.LineageCartouche, { lineageItems: lineageItems, key: section.key });
    }
    renderAnchor(section) {
        const item = section.items[0]; // Anchor sections should have only one item
        return react_1.default.createElement(LineageAnchor_1.LineageAnchor, Object.assign({}, this.getAnchorProps(item, section)));
    }
    renderSingleItem(section) {
        const item = section.items[0]; // Single-item sections should have only one item
        return react_1.default.createElement(SingleLineageItem_1.SingleLineageItem, Object.assign({}, this.getLineageItemProps(item, section)));
    }
    getLineageItemProps(item, section) {
        const unfilteredCount = this.props.unfilteredCounts && item.count(this.props.unfilteredCounts);
        const filteredCount = this.props.filteredCounts && item.count(this.props.filteredCounts);
        return {
            key: item.lineageItemType,
            label: this.getLineageLabel(item),
            countLoading: !!this.props.filteredItemName && this.props.countsLoading,
            filteredCount,
            unfilteredCount,
            lineageItemType: item.lineageItemType,
            isCurrentPane: (0, LineageConfiguration_1.lineageItemKey)({ lineageItem: item, lineageSection: section }) === this.props.activeLineageItemKey,
            linkHref: item.path(this.props.urls, this.props.itemId) + this.props.urlSearchValue,
            buttonAltText: item.messagesForLineage.withoutCount(),
        };
    }
    getAnchorProps(item, section) {
        return {
            key: item.lineageItemType,
            label: item.messagesForLineage.withoutCount(),
            lineageItemType: item.lineageItemType,
            isCurrentPane: (0, LineageConfiguration_1.lineageItemKey)({ lineageItem: item, lineageSection: section }) === this.props.activeLineageItemKey,
            linkHref: item.path(this.props.urls, this.props.itemId) + this.props.urlSearchValue,
            buttonAltText: item.messagesForLineage.withoutCount(),
            isFilteredOnThisType: item.lineageItemType === this.props.filteredOnItemType,
            anchorName: this.props.anchorName,
            selectedItemCount: this.props.filteredItemName ? 1 : 0,
            anchorCount: this.props.anchorCount,
        };
    }
}
exports.LineageNav = LineageNav;
//# sourceMappingURL=LineageNav.js.map